import React from 'react';
import { Button, Typography, Box, MenuItem, Select as MuiSelect, CircularProgress } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

// Shared presentation only. The live container supplies its existing handlers;
// onboarding supplies example data and inert/no-op handlers. No data hooks here.
export default function ConsultationWritePanel({ readOnly = false, generateComprehensiveReport, handleTemplateSelect, handleUploadTemplate, isGeneratingReport, selectedItems, selectedTemplate, setShowControlPanel, showControlPanel, templates }) {
  return (<Box sx={{ backgroundColor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                  <Box onClick={() => setShowControlPanel(!showControlPanel)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, cursor: 'pointer', '&:hover': { backgroundColor: '#F9FAFB' } }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827' }}>Write a Document</Typography>
                    {showControlPanel ? <KeyboardArrowDownIcon sx={{ color: '#6B7280' }} /> : <KeyboardArrowRightIcon sx={{ color: '#6B7280' }} />}
                  </Box>
                  {showControlPanel && (
                    <Box sx={{ px: 2, pb: 2, borderTop: '1px solid #F3F4F6', pt: 1.5 }}>
                      {/* Selected docs info */}
                      <Box sx={{ backgroundColor: '#F0FDFA', border: '1px solid #A7F3D0', borderRadius: '8px', p: 1.2, mb: 1.5 }}>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#065F46', display: 'block', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                          {selectedItems.length} document{selectedItems.length !== 1 ? 's' : ''} selected
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#059669', display: 'block', mt: 0.5, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                          Click files in the sidebar to select them for generation
                        </Typography>
                      </Box>

                      {/* Template dropdown + Upload on same row */}
                      <Typography variant="caption" sx={{ fontWeight: 600, color: '#6B7280', display: 'block', mb: 0.5 }}>Template</Typography>
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1.5, width: '100%' }}>
                        <MuiSelect
                          size="small"
                          value={selectedTemplate?.id || ''}
                          onChange={(e) => {
                            const t = templates.find(tmpl => tmpl.id === e.target.value);
                            if (t) handleTemplateSelect(t);
                          }}
                          displayEmpty
                          sx={{ 
                            width: '60%', 
                            minWidth: '60%', 
                            maxWidth: '60%', 
                            fontSize: '0.875rem' 
                          }}
                        >
                          <MenuItem disabled value="">
                            <em>{templates.length === 0 ? "No templates" : "Select Template"}</em>
                          </MenuItem>
                          {templates.map(t => (
                            <MenuItem key={t.id} value={t.id}>{t.title}</MenuItem>
                          ))}
                        </MuiSelect>
                        <Button
                          component="label"
                          variant="outlined"
                          size="small"
                          sx={{
                            width: '38%',
                            minWidth: '38%',
                            maxWidth: '38%',
                            flexShrink: 0,
                            textTransform: 'none',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            borderColor: '#D1D5DB',
                            color: '#374151',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            px: 0.5,
                            '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
                          }}
                        >
                          Upload
                          <input disabled={readOnly} type="file" hidden accept=".txt,.docx,.pdf" onChange={handleUploadTemplate} />
                        </Button>
                      </Box>

                      {/* Generate */}
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={!isGeneratingReport && <AutoAwesomeIcon sx={{ fontSize: 15 }} />}
                        disabled={isGeneratingReport || selectedItems.length === 0 || !selectedTemplate}
                        onClick={() => generateComprehensiveReport()}
                        sx={{
                          py: 1.2,
                          px: 1,
                          backgroundColor: '#7C3AED',
                          color: '#FFFFFF',
                          borderRadius: '12px',
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '0.8rem',
                          whiteSpace: 'normal',
                          lineHeight: 1.2,
                          textAlign: 'center',
                          wordBreak: 'break-word',
                          '&:hover': { backgroundColor: '#6D28D9' },
                          '&.Mui-disabled': { backgroundColor: '#DDD6FE', color: '#7C3AED' },
                        }}
                      >
                        {isGeneratingReport ? (
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Generating...
                          </span>
                        ) : (
                          'Generate'
                        )}
                      </Button>
                    </Box>
                  )}
                </Box>);
}
